import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from './Select';

import { getCompanies, clearCompanies } from '../../../../actions';

import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';

export const CompanySelect = ({
  dispatchGetCompanies,
  dispatchClearCompanies,
  companies,
  isLoading,
  isMulti,
  input,
  meta,
  isDisabled,
  ...rest
}) => {
  useLayoutEffect(
    () => () => dispatchClearCompanies(),
    [dispatchClearCompanies],
  );

  const onChangeCompany = (inputValue) => {
    const value = inputValue.trim();

    if (value.length < 4) {
      return;
    }

    const isNumeric = /^\d+$/.test(value);

    const query = isNumeric
      ? `business.businessTaxId:${value}`
      : `name:${value}`;

    dispatchGetCompanies({ query });
  };

  return (
    <Select
      options={companies}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      isDisabled={isDisabled}
      onInputChange={onChangeCompany}
      {...rest}
    />
  );
};

CompanySelect.propTypes = {
  dispatchGetCompanies: PropTypes.func.isRequired,
  dispatchClearCompanies: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  retrieveCompanyObject: PropTypes.bool,
};

CompanySelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  companies: [],
  isDisabled: false,
  retrieveCompanyObject: false,
};

const mapStateToProps = ({ ContractUnit }, { retrieveCompanyObject }) => ({
  companies: ContractUnit.Company.getIn(['all', 'content', 'content']).map(
    (company) => ({
      ...(!retrieveCompanyObject ? {} : company),
      value: company.id,
      label: company.business.businessTaxId
        ? `${company.name} - ${company.business.businessTaxId}`
        : company.name,
    }),
  ),

  isLoading: ContractUnit.Company.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetCompanies: getCompanies,
  dispatchClearCompanies: clearCompanies,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanySelect);
